<template>
  <v-row class="card-dimensions">
    <v-col
      class="title-divider"
      :class="{
        listcard: !readonly
      }"
      cols="12"
      @click.stop="$emit('click')"
    >
      <!-- Nombre del detalle de producción y botón de eliminar -->
      <div class="d-flex justify-content-between">
        <p class="title-responsive primary--text text-uppercase mb-0">
          {{ `${name ? name : ''} ${parseInt(name) > 0 ? $t('days') : ''}` }}
        </p>
        <i-btn
          v-if="remove"
          color="red"
          icon="fa-trash"
          outlined
          small
          :title="$tc('delete', 1)"
          @click.stop="$emit('remove')"
        ></i-btn>
      </div>

      <!-- Información del detalle de producción -->
      <div
        v-if="detail != null && remove"
        class="d-flex justify-content-between"
      >
        <!-- Oculto -->
        <v-switch
          class="v-switch mt-0"
          color="primary"
          disabled
          key="hidden-input"
          name="hidden"
          :label="$tc('hidden')"
          v-model="detail.hidden"
        ></v-switch>

        <!-- Tiene dimensiones -->
        <v-switch
          class="v-switch mt-0"
          color="primary"
          disabled
          key="have_dimensions-input"
          name="have_dimensions"
          :label="$tc('dimension')"
          v-model="detail.have_dimensions"
        ></v-switch>

        <!-- Selección múltiple -->
        <v-switch
          class="v-switch mt-0"
          color="primary"
          disabled
          key="multi_choice-input"
          name="multi_choice"
          :label="$tc('multi_choice')"
          v-model="detail.multi_choice"
        ></v-switch>

        <!--  Multiplicable por la cantidad -->
        <v-switch
          class="v-switch mt-0"
          color="primary"
          disabled
          key="is_multipliable-input"
          name="multi_choice"
          :label="$tc('is_multipliable')"
          v-model="detail.is_multipliable"
        ></v-switch>
      </div>

      <!-- Datos numéricos del detalle de producción -->
      <v-row class="my-0">
        <v-col
          v-if="detail && detail.calc"
          class="font-weight-bold pt-0"
          cols="12"
        >
          <span class="primary--text">{{ $t('type') }}:</span> {{ detail.calc }}
        </v-col>
        <v-col
          v-for="(attr, keydetail) in value"
          :key="`${'dimension'}-${keydetail}`"
          class="pt-0"
          cols="12"
        >
          <div class="primary--text font-weight-bold">
            {{ attr.name }}:
            <span
              class="caption font-weight-bold"
              v-if="attr.measure !== 'in' && attr.measure !== 'ft'"
            >
              {{ attr.value }} {{ attr.measure }}
            </span>
            <span class="caption font-weight-bold" v-if="attr.measure === 'in'">
              {{ attr.main }}
              {{ attr.decimalText }}
              {{ attr.measure }}
            </span>
            <span class="caption font-weight-bold" v-if="attr.measure === 'ft'">
              {{ attr.main }} ft {{ attr.second }} {{ attr.decimalText }} in
            </span>
          </div>
          <div v-if="attr.rounded && attr.value" class="caption">
            <span>{{ $t('rounded2') }}:</span>
            <span class="font-weight-bold">
              {{ attr.rounded }}
              {{
                attr['defaultMeasure'] !== undefined
                  ? attr['defaultMeasure']
                  : attr['measure']
              }}
            </span>
          </div>
        </v-col>
      </v-row>

      <!-- Alerta de no se qué -->
      <div
        v-if="
          (price || qty) &&
          ((detail != null &&
            detail.priceString === '' &&
            detail.price_type === 'matrix') ||
            (detail.price_type === 'formula' &&
              detail.priceString === '' &&
              JSON.parse(JSON.stringify(detail.dimensions) === '{}')))
        "
      >
        <v-alert type="info" outlined color="error">
          <span class="primary--text text-uppercase font-weight-black">
            {{ $tc('edit', 2) }} {{ $tc('value', 2) }}
          </span>
        </v-alert>
      </div>

      <!-- Precio y cantidad -->
      <v-row class="my-0">
        <v-col v-if="price || qty" cols="12" class="pb-3">
          <div
            v-if="
              (detail != null && detail.price_type === 'base') ||
              detail.priceString !== '' ||
              (detail.priceString === '' &&
                JSON.parse(JSON.stringify(detail.dimensions) !== '{}'))
            "
            class="d-flex flex-column justify-content-start"
          >
            <!-- Precio -->
            <p class="text-uppercase font-weight-black mb-0">
              <span class="primary--text">{{ $tc('price', 0) }}:</span>
              <i-money
                v-if="price !== '' && price !== null && price !== undefined"
                mode="text"
                :value="price"
              ></i-money>
            </p>

            <!-- Cantidad -->
            <p class="text-uppercase font-weight-black mb-0">
              <span v-if="qty" class="primary--text">
                {{ $tc('amount', 2) }}:
              </span>
              {{ detail.is_multipliable ? parseFloat(qty) : 1 }}
            </p>

            <!-- Subtotal -->
            <p
              v-if="price && qty"
              class="text-uppercase font-weight-black mb-0"
            >
              <span v-if="qty" class="primary--text">
                {{ $tc('subtotal', 1) }}:
              </span>
              <i-money :value="subtotal(detail)" mode="text"></i-money>
            </p>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    value: [Object, String],
    remove: Boolean,
    price: [Number, String],
    qty: [Number, String],
    name: [String],
    readonly: {
      type: Boolean,
      default: false
    },
    detail: {
      type: [Object, String],
      default: null
    }
  },
  data() {
    return {
      val: 1,
      save: false,
      detailForm: this.detail
    }
  },
  methods: {
    async submit() {
      if (this.save) {
        this.detailForm.price = this.price
        await this.$api.suborder.production.create({
          form: this.detailForm
        })
        this.$toast.success(
          `${this.$tc('details_production', 1)} ${this.$tc(
            this.detailForm.pk !== undefined ? 'edited' : 'created',
            2
          )}`
        )
        this.$emit('reload', false)
      }
    },
    /**
     * subtotal
     * Calcula el subtotal de cada detalle de producción
     *
     * @param {Object} item
     * @return {Number}
     */
    subtotal(item) {
      if (item.is_multipliable) {
        return parseFloat(item.price) * parseFloat(this.qty)
      }
      return parseFloat(item.price)
    }
  }
}
</script>
<style lang="sass">
.card-dimensions
  margin: 0

.title-divider
  border-top: 1px solid rgba(219, 219, 219, 0.5)
  padding-bottom: 12px

.theme--dark
  .title-divider
    border-top: 1px solid rgba(74, 74, 74, 0.8)
</style>
